import type { PaymentMethodsResponse } from './api';

/** A card is good through the whole printed month: expired once that month has ended (UTC). */
export function isCardExpired(card: { exp_month?: number; exp_year?: number } | undefined, now = new Date()): boolean {
  if (!card?.exp_month || !card.exp_year || card.exp_month < 1 || card.exp_month > 12) return false;
  return card.exp_year < now.getUTCFullYear()
    || (card.exp_year === now.getUTCFullYear() && card.exp_month < now.getUTCMonth() + 1);
}

/** Whether the card a card-paid start would hold against has expired, known BEFORE Start (Warren, 21 October).
 * That card is the driver's recorded default (start preview `card.paymentMethodId`), which can differ from the
 * Stripe invoice default the payment-methods list names; an older Api without the field falls back to the latter.
 * Unknown (no list yet, card not listed, no expiry) is not expired: the server stays authoritative. */
export function startCardExpired(startCardId: string | null | undefined, methods: PaymentMethodsResponse | undefined,
  now = new Date()): boolean {
  if (!methods) return false;
  const id = startCardId === undefined ? methods.default_payment_method : startCardId;
  if (!id) return false;
  return isCardExpired(methods.payment_methods.find(card => card.id === id), now);
}

/** An expired start card blocks a start that would hold on the card: card selected, card the only way to pay (a
 * Canadian price), or no source resolved. A wallet-paid start still goes; the driver is told either way. */
export function expiredCardBlocksStart(expired: boolean, selected: 'card' | 'wallet' | null, cardOnly: boolean): boolean {
  return expired && (cardOnly || selected !== 'wallet');
}
